/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import store from '@/store';
import * as api from '@/api/play';
import { PLAY } from '@/store/types';
import { updateObject } from '@/utils/util';
import { finalizeAction, ActionType } from '@/store/actions';
import { PlayService } from '@/api/types/play';

export interface StorePlayServiceMineState {
  services: PlayService[];
}

export default {
  namespaced: true,
  state: {
    services: null,
  },
  getters: {},
  actions: {
    [PLAY.GET_SERVICES](
      { state, commit },
      { action: rawAction = '' }: { action?: ActionType } = {},
    ) {
      const action = finalizeAction(rawAction, !!state.services);
      if (action) {
        return new Promise((resolve, reject) => {
          api.getUserServices(0).then((res) => {
            commit(PLAY.GET_SERVICES, res.data);
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
    [PLAY.CREATE_SERVICE]({ dispatch }, { engine, body }) {
      return new Promise((resolve, reject) => {
        api.postService(engine, body).then(() => {
          const oncomplete = (): void => resolve();
          dispatch(PLAY.GET_SERVICES, { action: 'refresh' })
            .then(oncomplete)
            .catch(oncomplete);
        }).catch(reject);
      });
    },
    [PLAY.MODIFY_SERVICE]({ commit, dispatch }, { id, body }) {
      return new Promise((resolve, reject) => {
        api.putService(id, body).then(() => {
          commit(PLAY.MODIFY_SERVICE, { id, assign: body });
          const oncomplete = (): void => resolve();
          Promise.all([
            dispatch(PLAY.GET_SERVICES, { action: 'refresh' }),
            store.dispatch(`play/service/detail/${PLAY.GET_SERVICE}`, { id, action: 'refresh' }),
          ]).then(oncomplete).catch(oncomplete);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [PLAY.GET_SERVICES](state, services) {
      state.services = services;
    },
    [PLAY.MODIFY_SERVICE](state, { id, assign, offset }) {
      const service = state.services && state.services.find(p => p.id === id);
      if (service) {
        updateObject(service, { assign, offset });
      }
    },
  },
};
